<template>
  <div id="main">

    <div class="details_edit">
      <div class="details_input">
        <div class="edit_title">Edit notes</div>
        <div>
          <textarea class="edit_input">{{note}}</textarea>
          <div class="scan-note" @click="scanNote">
            <img class="scan-icon" src="../../assets/image/common/scan.png" alt="">
            Scan parcel location
          </div>
        </div>
        <a @click="save" class="edit_a edit_a_blue">Save</a>
        <a @click="back" class="edit_a edit_a_gray">Cancel</a>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'EditRemark',
  data () {
    return {
      orderId: null,
      note: null
    }
  },
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].style = 'background-color: rgba(0, 0, 0, 0.2);'
  },
  created () {
    this.orderId = this.$route.query.orderId
    this.note = this.$route.query.note
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    scanNote () {
      let orderId = this.$route.query.orderId
      this.$router.push('/barcode?action=scanNote&orderId=' + orderId)
    },
    save () {
      const vue = this
      const note = $('.edit_input').val()
      this.axios({
        method: 'post',
        url: this.api.updateOrderNote,
        data: {
          note: note,
          ordersId: this.orderId
        }
      }).then(function (response) {
        vue.$router.push('/order/details?order=' + vue.orderId)
      }).catch(function (error) {
        console.log(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" src="../../assets/css/order/editremark.css" scoped>

</style>
<style scoped>
  .scan-note{
    position: absolute;
    padding-left: 0.15rem;
    padding-right: 0.15rem;
    font-weight: 400;
    font-family: 'Poppins-Regular';
    color:#5A5A5A;
    top: 1.45rem;
    left: 0.7rem;
    width:auto;
    height:0.3rem;
    line-height: 0.3rem;
    background:#fff;
    box-shadow:-0.03rem 0.06rem 0.09rem rgba(0,0,0,0.16);
    opacity:1;
    border-radius:0.13rem;
    font-size: 0.15rem;
  }
  .scan-icon{
    height: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Order/EditRemark.vue